import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Modal, message } from "antd";
import { SCHOOL_DATA_CONSTANTS } from "../../constants/schoolData";
import { EVENT_NAMES_CONSTANT, logFirebaseEvent } from "../../services/events";
import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import UserService from "../../utils/userService";
import { useParams } from "react-router-dom";
import ProductOrderDetails from "./ProductOrderDetails";
import TriggerComponent from "./TriggerComponent";
import LeadLogo from "../../assets/lead_logo.svg";
import "../../Opp.css";
import "../../MediaPreview.css";
import {
  HARDWARE_TYPE,
  OPP_CONSTANTS,
  ORDER_DATA_SUMMARY,
  ORDER_STATUS,
  PRODUCT_THEME,
} from "../../constants/OppContants";
import ModelPopup from "./ModelPopup";
import InfoComponent from "../InfoComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LOG_IN_TYPE } from "../../constants/auth";
import {
  fetchOrderDetails,
  submitOrderShipment,
} from "../../services/fetchApis";
import { ToastComponent } from "../ToastComponent";
import moment from "moment";
import CertificateComponent from "./CertificateComponent";
import MediaPreview from "../MediaPreview";
import AttachmentComponent from "./AttachmentComponent";

const OrderDetailsComponent = () => {
  const { orderId: orderIdParams } = useParams();
  const [toggleIndexs, setToggleIndex] = useState([0, 1, 2, 4]);
  const [searchText, setSearchText] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [orderId, setOrderId] = useState("");
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isAPILoading, setIsAPILoading] = useState(false);
  const [modalState, setModalState] = useState(false);
  const [isWarning, setShowWarning] = useState(false);

  const [productTriggers, setProductTrigger] = useState({});
  const [enableOrderSubmit, setEnableOrderSubmit] = useState(false);
  const [disableAllActions, setDisableAllAction] = useState(false);
  const [allQcTrigger, setAllQCTrigger] = useState(false);
  const [triggeredAll, setTriggeredAllQC] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);
  const [shipmentResources, setShipmentResources] = useState([]);
  const [showMediaPreview, setShowMediaPreview] = useState(false);
  const [showAttachments, setShowAttachments] = useState(false);
  const [disablePopupOkButton, setDisablePopupOkButton] = useState(false);
  const [linkState, setLinkState] = useState({ loading: false, copied: false });

  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    // if user is already logged in, logout if user does not have version
    if (process.env.REACT_APP_VERSION !== "2.0.0") UserService.handleLogout();

    // Cleanup the event listener when component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (orderIdParams) {
      setOrderId(orderIdParams);
      setSearchText(orderIdParams);
    }
  }, [orderIdParams]);

  useEffect(() => {
    if (orderId) {
      setErrorMessage(null);
      setLoading(true);
      setOrderData(null);
      fetchOrderData();
      navigate(`/opp/${orderId}`, {
        replace: true,
      });
    }
  }, [orderId]);

  async function fetchOrderData() {
    const orderDetails = await fetchOrderDetails(orderId);
    if (orderDetails && orderDetails?.data) {
      const myOrder = orderDetails?.data;
      setOrderData(myOrder);
      if (myOrder.resources && myOrder.resources.shipmentRef) {
        try {
          const shipmentRef = JSON.parse(myOrder.resources.shipmentRef);
          setShipmentResources(shipmentRef);
        } catch (error) {
          console.log("Invalid type of resources");
        }
      } else {
        setShipmentResources([]);
      }
    } else if (orderDetails && orderDetails?.status === "ERROR") {
      setErrorMessage(
        orderDetails?.message || OPP_CONSTANTS.messages.wentWrong
      );
    }
    setLoading(false);
  }

  useEffect(() => {
    if (
      orderData?.status &&
      orderData?.status?.toUpperCase() !== ORDER_STATUS.INPROGRESS.toUpperCase()
    ) {
      setDisableAllAction(true);
    } else {
      setDisableAllAction(false);
    }
  }, [orderData]);

  const updateOrderId = (value) => {
    if (!value) {
      setOrderId("");
      return;
    }
    if (value.length > 0) setOrderId(value);
  };

  const handleNavigation = () => {
    navigate(`/opp/create`, {
      replace: true,
    })
  }

  const handleSubmit = () => {
    let properties = {};
    if (searchText && searchText.length > 0) {
      updateOrderId(searchText);
      properties = {
        product_id: searchText,
        is_school_search: false,
        search_type: "opp",
      };
    }
    logFirebaseEvent(EVENT_NAMES_CONSTANT.search_button_clicked, properties);
  };

  const handleKeyPress = (target) => {
    if (target.charCode === 13) {
      handleSubmit();
    }
  };

  const errMessageText = () => {
    if (loading) return "Loading...";
    if (errorMessage) {
      return errorMessage;
    } else if (!!orderId && !orderData && !loading) {
      return OPP_CONSTANTS.messages.notAvailable;
    }
    return OPP_CONSTANTS.messages.default;
  };

  const triggerExpand = (index) => {
    if (!toggleIndexs.includes(index)) {
      setToggleIndex([...toggleIndexs, index]);
    } else {
      const newArray = toggleIndexs.filter((item) => item !== index);
      setToggleIndex([...newArray]);
    }
  };

  const handleAllQCStart = () => {
    setTriggeredAllQC(true);
    setAllQCTrigger(false);
  };

  const handleReadySubmit = () => {
    setModalState(true);
    setShowWarning(!enableOrderSubmit);
  };

  const handlePopupSubmit = async (inputText) => {
    setStatusMessage(null);
    setIsAPILoading(true);

    const user = UserService.getUserData();
    const loginType = UserService.getLogInType();
    let userId = null;
    if (loginType === LOG_IN_TYPE.nucleus) {
      userId = user?.id;
    } else {
      userId = user?.email;
    }

    const response = await submitOrderShipment(orderId, userId, inputText);
    if (response && response.status === "OK") {
      setStatusMessage(OPP_CONSTANTS.messages.successSubmit);
      setModalState(false);
      setOrderData({
        ...orderData,
        completedAt: "" + moment().unix() * 1000,
        status: "Completed",
      });
      setIsAPILoading(false);
    } else if (response && response.status === "ERROR" && response.message && response.message.includes("Shipment is already created")) {
      setIsAPILoading(false);
      setStatusMessage(response.message);
      setDisableAllAction(true);
      setDisablePopupOkButton(true);
      // After 5 seconds, re-enable both and refresh order details
      setTimeout(() => {
        setDisableAllAction(false);
        setDisablePopupOkButton(false);
        setModalState(false); // Close the popup
        fetchOrderData();
      }, 5000);
    } else {
      setIsAPILoading(false);
      setStatusMessage(
        response?.message || OPP_CONSTANTS.messages.failToSubmit
      );
    }
    setIsAPILoading(false);
  };

  const handleToastClose = () => {
    setStatusMessage(null);
  };

  const handleSubmitClose = () => {
    setStatusMessage(null);
    setModalState(false);
  };
  const onOrderStatusUpdated = (enable) => {
    setEnableOrderSubmit(enable);
  };

  const onDeviceTriggerStatusUpdated = (enabledCount, produtType) => {
    let totalDevice = 0;
    orderData?.orderDetails?.map((data, index) => {
      const validTabDevices = Object.keys(data?.deviceInfo)?.filter((key) => {
        const isValidDevice =
          data?.deviceInfo[key]?.deviceType?.toUpperCase() ===
          HARDWARE_TYPE.TAB.name.toUpperCase();
        return isValidDevice;
      });

      totalDevice = totalDevice + validTabDevices.length;
    });

    setProductTrigger((prev) => {
      const productTriggers = { ...prev };
      productTriggers[produtType] = enabledCount;
      return productTriggers;
    });

    let atProductEnabledCount = enabledCount;
    Object.keys(productTriggers).map((key, index) => {
      if (key != produtType) {
        atProductEnabledCount = atProductEnabledCount + productTriggers[key];
      }
    });

    let canTriggerAll =
      totalDevice > 0 && totalDevice === atProductEnabledCount;
    setAllQCTrigger(canTriggerAll);
  };

  const cardDetailsLayout = (index, theme, value, valueName) => {
    return (
      <Col className="product-info-col">
        <div className="summary-value" style={{ color: theme.color }}>
          {!!value ? value : "NA"}
        </div>
        <div className="summary-label">{valueName}</div>
      </Col>
    );
  };

  const showUserInfo = () => {
    const user = UserService.getUserData();
    return (
      <div className="user-details-container">
        <div className="search-container">
          <Form.Control
            onChange={(e) => setSearchText(e.target.value)}
            className="search-input"
            id="inlineFormInput"
            placeholder="Please Enter Order Id"
            type={searchText}
            value={searchText}
            onKeyPress={handleKeyPress}
          />
          <div className="search-button">
            <Button onClick={handleSubmit}>
              {SCHOOL_DATA_CONSTANTS.btns.search}
            </Button>
          </div>
        </div>
        {windowWidth > 1000 && (
          <div className="user-info-container">
            <div className="create-button">
              <Button onClick={handleNavigation}>
                {SCHOOL_DATA_CONSTANTS.btns.create}
              </Button>
            </div>
            <div>
              <div>
                Welcome, <strong>{`${user.name}`}</strong>
              </div>
              <div className="role-badge">{user.rolename}</div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleMediaPreviewShow = () => {
    setShowMediaPreview(true);
  };

  const handleMediaPreviewClose = () => {
    setShowMediaPreview(false);
  };

  const handleUploadSuccess = (syncedFile) => {
    console.log(syncedFile);
    setShipmentResources(syncedFile);
  };

  const handleAttahmentsOpen = () => {
    setShowAttachments(true);
  };

  const handleAttahmentsClose = () => {
    setShowAttachments(false);
  };

  const hasTabDeviceInOrder = !!orderData?.orderDetails?.some((detail) =>
    Object.values(detail?.deviceInfo ?? {}).some(
      (device) =>
        device?.deviceType?.toUpperCase() ===
        HARDWARE_TYPE.TAB.name.toUpperCase()
    )
  );

  const showTriggerBlockedMessage =
    orderData?.oneNucleusValid === false && hasTabDeviceInOrder;

  const handleGenerateReportLink = async () => {
    setLinkState({ loading: true, copied: false });
    try {
      const response = await fetch(
        `${process.env.REACT_APP_GREENFIELD_URL}/api/installation-report/generate-link`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_SCHOOL_API_KEY,
          },
          body: JSON.stringify({ soNo: orderId }),
        }
      );
      const result = await response.json();
      if (!response.ok || !result.success) throw new Error(result.message);
      const link = `${window.location.origin}${window.location.pathname}#/installation-report?token=${result.token}`;
      await navigator.clipboard.writeText(link);
      setLinkState({ loading: false, copied: true });
      message.success('Link copied to clipboard! Valid for 7 days.');
      setTimeout(() => setLinkState({ loading: false, copied: false }), 3000);
    } catch (err) {
      setLinkState({ loading: false, copied: false });
      message.error(err.message || 'Failed to generate link');
    }
  };

  return (
    <div>
      <>
        <div className="top-header-inner-container py-3">
          <FontAwesomeIcon
            icon="home"
            size="2x"
            style={{ marginRight: "10px" }}
            onClick={() =>
              navigate(`/`, {
                replace: true,
              })
            }
          />
          <img className="lead-logo" src={LeadLogo} alt="lead-logo"></img>
          {showUserInfo()}
        </div>
      </>
      <div style={{ paddingTop: "83px" }}>
        {!!orderData && !loading ? (
          <>
            <div className="top-header-order-container py-3">
              {orderData && (
                <>
                  <div
                    className="order-detail-top-container"
                    style={{
                      borderRight: `1px solid #ff5f00`,
                    }}
                  >
                    <Row className="kpi-order-label">
                      {OPP_CONSTANTS.title.orderSummary}
                      <div className="kpi-order-value">{orderId}</div>
                    </Row>

                    <FontAwesomeIcon
                      icon={
                        shipmentResources.length > 0
                          ? "fa-photo-film"
                          : "fa-paperclip"
                      }
                      onClick={handleMediaPreviewShow}
                      style={{ margin: "10px", fontSize: "28px" }}
                    />

                    {showTriggerBlockedMessage && (
                      <div className="trigger-blocked-message" style={{ paddingTop: 6 }}>
                        Trigger is blocked for TAB devices, please contact TA Tech/Product
                      </div>
                    )}

                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
                      <div className="opp-button-container" style={{ flexBasis: 'auto' }}>
                        <div className="opp-button">
                          <Button
                            onClick={handleGenerateReportLink}
                            disabled={linkState.loading || !orderId}
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            {linkState.loading ? 'Generating...' : linkState.copied ? 'Link Copied!' : 'Installation Report Link'}
                          </Button>
                        </div>
                      </div>
                      <TriggerComponent
                        disabled={disableAllActions || !allQcTrigger}
                        title={OPP_CONSTANTS.btns.startAll}
                        handleSubmit={handleAllQCStart}
                      />
                    </div>
                  </div>

                  <CertificateComponent
                    isAtDevice={false}
                    isForSDCard={false}
                    status={{
                      title: "Order Status & Summary",
                      status: orderData.status,
                      remarks: orderData.reason,
                      summary: (
                        <Card size="small" style={{ marginTop: "20px" }}>
                          <p style={{ lineHeight: "1.6" }}>
                            Status:
                            <span
                              style={{
                                color:
                                  orderData.status?.toUpperCase() ===
                                    ORDER_STATUS.COMPLETED?.toUpperCase()
                                    ? "green"
                                    : "red",
                              }}
                            >
                              <strong> {orderData.status} </strong>
                            </span>
                            <br />
                            Completed By:
                            <strong> {orderData.completedBy}</strong>
                            <br />
                            Completed At:
                            <strong> {orderData.completedAt}</strong>
                            <br />
                            Comments:
                            <strong> {orderData.reason}</strong>
                          </p>
                        </Card>
                      ),
                    }}
                  />
                </>
              )}
            </div>
            <div className="product-card-title-container">
              {orderData &&
                Object.entries(
                  orderData?.orderDetails?.reduce((acc, item) => {
                    const key = `${item.productType}__${item.schoolId}`;
                    if (!acc[key]) acc[key] = [];
                    acc[key].push(item);
                    return acc;
                  }, {})
                ).map(([key, groupedItems], index) => {
                  const sampleItem = groupedItems[0]; // Use for card header
                  let productType = sampleItem.productType.toUpperCase().split(' ').join('_');
                  let productTheme = PRODUCT_THEME[productType] ?? PRODUCT_THEME.OTHER;

                  return (
                    <Card
                      key={`grouped_product_card_${index}`}
                      size="small"
                      hoverable
                      title={
                        <Row
                          className="product-info-header"
                        // onClick={() => {
                        //   triggerExpand(index);
                        // }}
                        >
                          {cardDetailsLayout(
                            1,
                            productTheme,
                            sampleItem.productType,
                            ORDER_DATA_SUMMARY.ORDER_DETAILS.productType
                          )}

                          {cardDetailsLayout(
                            2,
                            productTheme,
                            sampleItem.schoolId,
                            ORDER_DATA_SUMMARY.ORDER_DETAILS.schoolId
                          )}

                          {sampleItem.sdCardProfileName &&
                            cardDetailsLayout(
                              3,
                              productTheme,
                              sampleItem.sdCardProfileName,
                              ORDER_DATA_SUMMARY.ORDER_DETAILS.profileName
                            )}

                          {/* {cardDetailsLayout(
                            3,
                            productTheme,
                            data.schoolName,
                            ORDER_DATA_SUMMARY.ORDER_DETAILS.schoolName
                          )} */}
                          {cardDetailsLayout(
                            3,
                            productTheme,
                            groupedItems.reduce((total, o) => o.deviceInfo.length + total, 0),
                            ORDER_DATA_SUMMARY.ORDER_DETAILS.deviceCount
                          )}

                          {/* <Row
                            className="product-info-row"
                            style={{
                              width: "150px",
                            }}
                          >
                            <img
                              className="product-logo"
                              src={productTheme.icon}
                            ></img>
                            <FontAwesomeIcon
                              icon={
                                toggleIndexs.includes(index)
                                  ? "chevron-up"
                                  : "chevron-down"
                              }
                              size="2x"
                              style={{ marginRight: "10px" }}
                            />
                          </Row> */}
                        </Row>
                      }
                      style={{
                        marginBottom: "10px",
                        border: "1px solid",
                        borderColor: productTheme.color,
                        backgroundColor: productTheme.color + "11",
                      }}
                      headStyle={
                        toggleIndexs.includes(index)
                          ? { padding: "0px" }
                          : { border: "0px", padding: "0px" }
                      }
                      bodyStyle={{
                        padding: "0px",
                        margin: "0px",
                        backgroundColor: "#fff",
                      }}
                    >
                      {groupedItems.map((data, i) => (
                        <ProductOrderDetails
                          key={`product_detail_${index}_${i}`}
                          orderId={orderId}
                          disableAllActions={disableAllActions}
                          deviceActionStatus={orderData.deviceActions ?? []}
                          oneNucleusValid={orderData?.oneNucleusValid}
                          productOrderData={data}
                          productType={productType}
                          triggeredAll={triggeredAll}
                          expand={toggleIndexs.includes(index)}
                          onDeviceTriggerStatusUpdated={(count) =>
                            onDeviceTriggerStatusUpdated(count, productType)
                          }
                          onOrderStatusUpdated={(enable) => {
                            onOrderStatusUpdated(enable);
                          }}
                        />
                      ))}
                    </Card>
                  );
                })}
            </div>

            <div className="shipment-btn">
              <div>
                <TriggerComponent
                  title={
                    disableAllActions &&
                      orderData?.status &&
                      orderData.status.toUpperCase() === ORDER_STATUS.COMPLETED.toUpperCase()
                      ? OPP_CONSTANTS.btns.submittedShipment
                      : OPP_CONSTANTS.btns.readyShipment
                  }
                  bgColor={
                    disableAllActions &&
                      orderData?.status &&
                      orderData.status.toUpperCase() === ORDER_STATUS.COMPLETED.toUpperCase()
                      ? "#336D0055"
                      : null
                  }
                  disabled={!enableOrderSubmit || disableAllActions}
                  actionable={!disableAllActions || enableOrderSubmit}
                  handleSubmit={handleReadySubmit}
                />
              </div>
              {statusMessage && !modalState && (
                <ToastComponent
                  message={statusMessage}
                  duration={3000}
                  handleToastClose={handleToastClose}
                />
              )}
            </div>
          </>
        ) : (
          <InfoComponent message={errMessageText()} />
        )}
      </div>

      <div style={{ position: "absolute" }}>
        <ModelPopup
          show={modalState}
          showUpload={!disableAllActions}
          iconName={
            isWarning
              ? OPP_CONSTANTS.icons.warning
              : OPP_CONSTANTS.icons.confirm
          }
          iconColor={isWarning ? "orange" : "gray"}
          title={
            isWarning
              ? OPP_CONSTANTS.title.warning
              : OPP_CONSTANTS.title.confirm
          }
          okTitle={
            isWarning
              ? OPP_CONSTANTS.btns.readyShipment
              : OPP_CONSTANTS.btns.confirm
          }
          okDisabled={disablePopupOkButton}
          cancelTitle={OPP_CONSTANTS.btns.cancel}
          hasInput={isWarning}
          placeholder={
            isWarning
              ? OPP_CONSTANTS.messages.warningHint
              : OPP_CONSTANTS.messages.confirm
          }
          handleOkClick={handlePopupSubmit}
          handleClose={handleSubmitClose}
          uploadedMediaFiles={shipmentResources}
          showLoading={isAPILoading}
          errMessage={statusMessage}
          orderId={orderId}
          handleUploadSuccess={handleUploadSuccess}
        />

        <MediaPreview
          showMediaPreview={showMediaPreview}
          shipmentResources={shipmentResources}
          windowWidth={windowWidth}
          windowHeight={windowHeight}
          handlePreviewClose={handleMediaPreviewClose}
          handleAttahmentsOpen={handleAttahmentsOpen}
          orderId={orderId}
          handleUploadSuccess={handleUploadSuccess}
        />

        <Modal
          open={showAttachments}
          destroyOnClose={true}
          footer={[]}
          onCancel={handleAttahmentsClose}
        >
          <AttachmentComponent
            orderId={orderId}
            okTitle={OPP_CONSTANTS.btns.upload}
            uploadedMediaFiles={shipmentResources}
            handleUploadSuccess={handleUploadSuccess}
          />
        </Modal>
      </div>
    </div>
  );
};
export default OrderDetailsComponent;
